import React, { useContext, useEffect, useState, useRef , useCallback } from "react";
import FroalaEditor from "react-froala-wysiwyg";
import Froalaeditor from "froala-editor";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import EditReportIcon from "../../../../components/SVGComponents/EditReportIcon";
import GPTMicIcon from "../../../../components/SVGComponents/GPTMicIcon";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { isChestXrayOrCtBrainStudy } from "../../../../service/MaskImageService";
import {
  DefaultButton,
  mergeStyles,
  Pivot,
  PivotItem,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import {
  BackgroundColorIcon,
  PreviewIcon,
  RefreshIcon,
} from "@fluentui/react-icons-mdl2";
import {
  NONXRAYMODALITIES,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
  USERTYPES,
} from "../../../../constants/Constants";
import DownloadIcon from "../../../../components/SVGComponents/DownloadIcon";
import UploadIcon from "../../../../components/SVGComponents/UploadIcon";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import RowBadge from "../../../StudyList/components/Badge/RowBadge";
import { getReportTemplatesData } from "../../../../service/StudyReportService";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";
// import Observations from "../SmartReporting/Observations";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import FormatterAgentModal from "../../../StudyList/components/Modal/FormatterAgent/FormatterAgentModal";
import userContext from "../../../../context/users/UserContext";
import { isMobile } from "react-device-detect";

const CustomEditor = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const froalaInstanceRef = useRef(null);
  const computeBaseHeight = useCallback(() => {
    const offset = SHOW_NOT_ORIGNAL_MODALITY_LIST.includes(props.modality)
      ? 150
      : props.showPathologyOptions
      ? 215
      : 150;
      
    return window.innerHeight - offset;
  }, [props.modality, props.showPathologyOptions]);
  const [containerHeight, setContainerHeight] = useState(computeBaseHeight());


 // Update height on resize
  useEffect(() => {
      console.log("custom height : ", props.customHeight);
    const updateHeight = () => {
      const newHeight = computeBaseHeight();
      setContainerHeight(newHeight);
      if (froalaInstanceRef.current) {
        froalaInstanceRef.current.setHeight(newHeight);
      }
    };

    window.addEventListener('resize', updateHeight);
    updateHeight();

    return () => window.removeEventListener('resize', updateHeight);
  }, [computeBaseHeight]);
  
  const [t, i18n] = useTranslation();
  const [editReport, setEditReport] = useState(true);
  const [disableCopyPaste, setDisableCopyPaste] = useState(true);
 
  const [editorReady, setEditorReady] = useState(false);
  const {themeName}=useContext(themeContext);

  const {userId,privilegedFirmDoctor, enableLlmReport} = useContext(userContext);

  // const [isFormattingLoading, setIsFormattingLoading] = useState(false);
  // const [formattedText, setFormattedText] = useState("");


  const {
    refreshReport,
    patientReports,
    activeTab,
    setActiveTab,
    disableAddendumTab,
    addendumModel,
    setAddendumModel,
    downloadFistolugram,
    showFistolugram,
    openFistolugramUploadModal,
    setFistolugramUploadModal,
    fistolugramFilePath,
    setAlertSuccessModal,
    alertSuccessModal,
    isClientReportExist,
    showQCReasonBadge,
    setOpenQcReasonModal,
    allReportTemplates,
    isChildStudyReportState,
    showMsWord,
    isWordFilePath,
    userRole,
    allowCopyPaste,
    isRestrictionsEnabled,
    // disableObservations,
    editorRef,
    openReportModal,
    fetchS10Report,
    showFormatterPopup, setShowFormatterPopup,
    setDisableCopyButton, disableCopyButton,
    isReportContentChanged, setDisableResetReport,
    isAdvanceViewer,
    studyDescription
  } = useContext(studyReportContext);


  useEffect(() => {
    let ele = document.getElementsByClassName("fr-toolbar");
    if (ele[0] != undefined) {
      if (ele[0].style != undefined) {
        // console.log(ele[0].style);
        ele[0].style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (editReport) {
        let ele = document.getElementsByClassName("fr-toolbar");
        if (ele[0] != undefined) {
          if (ele[0].style != undefined) {
            // console.log(ele[0].style);
            ele[0].style.display = "";
          }
        }
      } else {
        let ele = document.getElementsByClassName("fr-toolbar");
        if (ele[0] != undefined) {
          if (ele[0].style != undefined) {
            // console.log(ele[0].style);
            ele[0].style.display = "none";
          }
        }
      }
    }, 500);
  }, [editReport]);

  const {
    model,
    setModel,
    childModel,
    childPatientReports,
    childCurrentActiveTab,
    handleModelChange,
    firstReportAdded,
    setFirstReportAdded,
    selectedCategoryTemplate,
    studyId,
    currentActiveTab,
    reviewerId,
    reviewStatus
  } = useContext(studyReportContext);

  const {
    s10User,
    s10Url,
    formatterAgentEnabled
  } = useContext(studyReportContext);

  useEffect(() => {
    if (firstReportAdded == true) {
      setTimeout(() => {
        setEditReport(true);
      }, 100);
    }
  }, [firstReportAdded]);

  // //Disable editing in mobile read-only mode
  // useEffect(()=>{
  //   if(props.readOnly && isMobile){
  //     setEditReport(false);
  //   }
  // },[props.readOnly,isMobile]);
  useEffect(() => {
    if (patientReports.length == 0) {
      setFirstReportAdded(false);
      setEditReport(true);
    }
  }, [patientReports]);

  const checkForClientReport = async () => {
    let studyId = window.location.pathname.substring(
      window.location.pathname.lastIndexOf("/") + 1
    );
    console.log("--- Study Id ---", studyId);
    const ret = await getReportTemplatesData(studyId);
    if (ret.status === 200) {
      if (ret.data.data?.clientReportTemplates?.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  };


  const config = {
    placeholderText: "Your Report Will Come Here!",
    key: process.env.REACT_APP_FROALA_API_KEY,
    attribution: false,
    charCounterCount: false,
    height: containerHeight,
    width: 818,
    fontSize: [
      "8",
      "9",
      "10",
      "10.67",
      "11",
      "12",
      "13",
      "13.33",
      "14",
      "14.67",
      "15",
      "16",
      "17",
      "17.33",
      "18",
      "18.67",
      "19",
      "21.33",
      "24",
      "30",
      "36",
      "48",
      "60",
      "72",
      "96",
    ],
    fontSizeDefault: "12",
    fontSizeUnit: "px",
    lineHeights: {
      Default: "1.5",
      Single: "1",
      1.15: "1.15",
      1.5: "1.5",
      Double: "2",
    },
    fontFamilyDefaultSelection: "Times New Roman, serif",
    paste: false, // Disable paste functionality
    pastePlain: false,
    pasteAllowedStyleProps: [],
    wordPasteModal: false,
    pluginsEnabled: [
      "fullscreen",
      "codeBeautifier",
      "colors",
      "fontFamily",
      "lineHeight",
      "fontSize",
      "paragraphFormat",
      "paragraphStyle",
      "align",
      "lists",
      "table",
      "wordPaste"
    ],
    toolbarButtons: {
      moreText: {
        buttons: [
          "undo",
          "redo",
          "|",
          "paragraphFormat",
          "lineHeight",
          "|",
          "fontFamily",
          "|",
          "fontSize",
          "|",
          "bold",
          "italic",
          "underline",
          "|",
          "fullscreen",
          "|",
          "formatOL",
          "formatUL",
          "strikeThrough",
          "clearFormatting",
          "|",
          "textColor",
          "backgroundColor",
          "|",
          "alignLeft",
          "alignCenter",
          "alignRight",
          "alignJustify",
          // 'inlineClass',
          // 'inlineStyle',
          "outdent",
          "indent",
          "|",
          "insertTable",
          "|",
          "copy",
        ],
        align: "left",
        buttonsVisible: 11,
      },
    },
    lineHeights: {
      1.15: "1.15",
      1.5: "1.5",
      Double: "2",
    },
    events: {
      "paste.before": function (e) {
        // console.log("---checkForClientReport----");
        // const localCheck = checkForClientReport();
        console.log(
          "IsClientReportExist",
          isClientReportExist,
          allReportTemplates
        );
        if (
          (isRestrictionsEnabled &&
            (isClientReportExist ||
              allReportTemplates?.clientReportTemplates?.length > 0) &&
            !allowCopyPaste) ||
          process.env.REACT_APP_PROTECTED_MODE == "true"
        ) {
          console.log("--- Blocking copy paste ----");
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description = t("string-literals.copy-paste-disabled");
            return newItem;
          });
          return false;
        } else {
          return true;
        }
      },
    },
  };

  // useEffect(() => {
  //     // Access the Froala Editor instance through the ref
  //     if(editorRef.current != null){
  //         const editorInstance = editorRef.current.editor;
  //         console.log("hello",activeTab);
  //         // Set the default font size for the editor content
  //         editorInstance.$el.css('font-size', '11px');

  //         const parentDiv = document.querySelector('.fr-element.fr-view');

  //         const childDiv = parentDiv.firstChild;

  //         childDiv.style.fontSize = '11px';
  //     }

  //   }, [activeTab,editorRef]);

  useEffect(() => {
    if (editorRef !== null && editorReady) {
      const editorInstance = editorRef.editor;

      const disableCopyPaste = (e) => {
        // Check if the key combination is for copy (Ctrl + C) or paste (Ctrl + V)
        if (
          (e.ctrlKey || e.metaKey) &&
          (e.key === "c" || e.key === "C" || e.key === "v" || e.key === "V")
        ) {
          console.log("Calling");
          e.preventDefault();
          return false;
        }
      };

      editorInstance.events.on("keydown", disableCopyPaste);

      // Disable copy-paste through toolbar buttons
      const disableToolbarButtons = (e) => {
        const command = e.command || e;

        if (command === "copy" || command === "paste") {
          e.preventDefault();
          return false;
        }
      };

      editorInstance.events.on("beforeCommand", disableToolbarButtons);
    }
  }, [editorRef, editorReady]);

  const emptyConfig = {
    placeholderText: "Add report first to submit",
    key: process.env.REACT_APP_FROALA_API_KEY,
    attribution: false,
    charCounterCount: false,
    height: containerHeight,
    width: 800,
    events: {
      initialized() {
        // setTimeout is because there is a bug in v3 that
        // calls initialized before editor has finished initializing
        setTimeout(() => {
          this.edit.off();
        });
      },
    },
  };

  let msWordConfig = {
    placeholderText: "",
    key: "FROALA_KEY",
    attribution: false,
    height: containerHeight,
    width: 800,
    events: {
      initialized() {
        // setTimeout is because there is a bug in v3 that
        // calls initialized before editor has finished initializing
        setTimeout(() => {
          this.edit.off();
        });
      },
    },
  };
  Froalaeditor.DefineIcon("copy", { NAME: "insert", SVG_KEY: "add" });
  Froalaeditor.RegisterCommand("copy", {
    title: "Copy",
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      var html = this.html.get();
      var div = document.createElement("div");
      div.innerHTML = html;
      // console.log(div.innerText);
      var textField = document.createElement("textarea");
      // console.log(div.innerHTML);
      textField.innerHTML = html;
      // console.log(textField);
      textField.select();
      document.execCommand("selectall", null, false);
      document.execCommand("copy");
      // console.log(html);
      if (html != "") {
      }

      textField.remove();
    },
  });

  useEffect(()=>{
    console.log("report modal", openReportModal);
    setModel("");
  }, [openReportModal]);


  useEffect(() => {
    let temp = activeTab;
    setActiveTab(temp);
  }, [firstReportAdded]);

  // useEffect(() => {
  //   // console.log(activeTab);
  //   if (activeTab == 1) {
  //     let ele = document.getElementsByClassName("custom-tab");
  //     if (!ele[0].classList.contains("custom-tab-line"))
  //       ele[0].classList.add("custom-tab-line");
  //     if (ele[1].classList.contains("custom-tab-line"))
  //       ele[1].classList.remove("custom-tab-line");
  //   }
  //   if (activeTab == 2) {
  //     let ele = document.getElementsByClassName("custom-tab");
  //     if (!ele[1].classList.contains("custom-tab-line"))
  //       ele[1].classList.add("custom-tab-line");
  //     if (ele[0].classList.contains("custom-tab-line"))
  //       ele[0].classList.remove("custom-tab-line");
  //   }
  //   // let ele = document.getElementsByClassName("fr-toolbar");
  //   // if(ele[0] != undefined){
  //   //     if(ele[0].style != undefined){
  //   //         console.log(ele[0].style);
  //   //         ele[0].style.display = "";
  //   //     }
  //   // }
  //   // console.log(ele);
  // }, [activeTab]);

  useEffect(() => {
    if (props.isChild != null && props.isChild != undefined) {
      const frWrapper = document.querySelector(".fr-wrapper");
      if (frWrapper) {
        if (props.isChild) {
          frWrapper.style.background = "#c5c5c5";
        } else {
          frWrapper.style.background = "#FFF";
        }
      }
    }
  }, [props.isChild, childModel, document.querySelector(".fr-wrapper")]);


    const hasText = html => {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
    
      const normalize = str => str.replace(/\s+/g, ' ').trim();
      const actual = normalize(tmp.textContent);
      return !!actual;
    };
    

  return (
    <div
      className="new-editor-section"
      style={{ margin: enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription )  ? "0.5%" : 0 , position: "relative", height: "100%", boxSizing: "border-box",colorScheme:`${themeName==='light'?'none':'inherit'}` }}
    >

      {!(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription )) && isWordFilePath && (
        <div id="wordMessageContainer" className="word-message-container">
          <span>
            {userRole == USERTYPES.FIRMADMIN || userRole == USERTYPES.ADMIN || privilegedFirmDoctor
              ? t("string-literals.disable-editor-for-msword-admin") : userRole == USERTYPES.RADIOLOGIST && reviewerId && reviewerId == userId && reviewStatus != 1
              ? t("string-literals.disable-editor-for-msword-reviewer") 
              : t("string-literals.disable-editor-for-msword-non-admin")}
          </span>
        </div>
      )}
       
      { !(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription ) ) && (
      <div className="tab-add-refresh-section">
        <div className="edit-report-icon">
          {!props.readOnly  && activeTab != 3 && (
            <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEditReport((prev) => !prev);
            }}
          >
            <EditReportIcon active={editReport} />
          </span>)}

          <div style={{ marginLeft: "10px", cursor: "not-allowed" }}>
            {/* <GPTMicIcon/> */}
          </div>
        </div>

        {/* TODO */}
        {selectedCategoryTemplate !== "dsrTemplate" ? <div className="custom-tab-section">
          <button
            className={`custom-tab ${activeTab === 1 ? "custom-tab-line" : ""}`}
            onClick={() => {
              setEditReport(true);
              // if(!(isMobile && props.readOnly)){
              //   setEditReport(true);
              // }
              setActiveTab(1);
            }}
          >
            <span style={{color:getThemeColor("primary-color")}} className="custom-tab-text">
              Final Report
            </span>
          </button>
          <button
            style={{ cursor: disableAddendumTab ? "not-allowed" : "pointer" }}
            className={`custom-tab ${activeTab === 2 ? "custom-tab-line" : ""}`}
            onClick={() => {
              setEditReport(true);
              // if(!(isMobile && props.readOnly)){
              //   setEditReport(true);
              // }
              setActiveTab(2);
            }}
            disabled={disableAddendumTab}
          >
            <span style={{color:getThemeColor("primary-color")}} className="custom-tab-text">Addendum</span>
          </button>
          
        </div>
        :
        <div className="custom-tab-section">
          {/* <button
            style={{ cursor: disableObservations ? "not-allowed" : "pointer" }}
            className={`custom-tab ${activeTab === 3 ? "custom-tab-line" : ""}`}
            onClick={() => {
              setEditReport(true);
              // if(!(isMobile && props.readOnly)){
              //   setEditReport(true);
              // }
              setActiveTab(3);
            }}
            disabled={disableObservations}
          >
            <span
              style={{ color: getThemeColor("primary-color") }}
              className="custom-tab-text"
            >
              Observations
            </span>
          </button> */}
          <button
            style={{ cursor: "pointer" }}
            className={`custom-tab ${activeTab === 1 ? "custom-tab-line" : ""}`}
            onClick={() => {
              setEditReport(true);
              // if(!(isMobile && props.readOnly)){
              //   setEditReport(true);
              // }
              setActiveTab(1);
            }}
            // disabled={disableAddendumTab}
          >
            <span
              style={{ color: getThemeColor("primary-color") }}
              className="custom-tab-text"
            >
              Final Report
            </span>
          </button>
        </div>
        }

        <div
          onClick={() => {}}
          className="refresh-section"
          style={{ position: "relative" }}
        >
          {!(isMobile && props.readOnly) && !props.isChild && showFistolugram && (
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              style={{
                position: "absolute",
                left: `${showQCReasonBadge ? "-119px" : "-168px"}`,

                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{ marginRight: "10px" }}
                className="viewer-fistolugram-text"
              >
                <RowBadge tooltipText="Fistolugram" name="FIS..." />{" "}
              </span>
              <CustomToolTipHost content={t("button.download")}>
                <span
                  onClick={() => downloadFistolugram(false)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                >
                  <DownloadIcon />
                </span>
              </CustomToolTipHost>
              <CustomToolTipHost content={t("button.upload")}>
                <span
                  onClick={() => setFistolugramUploadModal(true)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                >
                  <UploadIcon />
                </span>
              </CustomToolTipHost>
              <CustomToolTipHost content={t("button.preview")}>
                <span
                  onClick={() => {
                    fistolugramFilePath != null
                      ? downloadFistolugram(true)
                      : console.log("No Fistolugram");
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor:
                      fistolugramFilePath == null ? "not-allowed" : "pointer",
                  }}
                >
                  <EyeIcon
                    color={fistolugramFilePath == null ? "#585858" : "#C1C1C1"}
                  />
                </span>
              </CustomToolTipHost>
            </div>
          )}
          {!(isMobile && props.readOnly) && showQCReasonBadge && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setOpenQcReasonModal(true);
              }}
              style={{
                position: "absolute",
                left: "-85px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <span style={{}} className="viewer-fistolugram-text">
                <RowBadge tooltipText="QC Reason" name="QC R..." />{" "}
              </span>
            </div>
          )}

          {s10User && <div className="refresh-button">
            <PrimaryButton
              iconProps={{
                iconName: "CloudDownload",
                cursor: "pointer",
              }}
              onClick={() => {
                if (!props.isChild) {
                  fetchS10Report();
                }
              }}
              style={{ padding: "0px 5px", margin: "0px 5px" }}
              text={t("button.s10-report")}
            />
            {/* <RefreshIcon />
            <span className="refresh-text">Refresh</span> */}
          </div>
          }

        {/* {formatterAgentEnabled && <div className="format-button">
              <Button
                id="formatter-agent"
                iconProps={{ iconName: isFormattingLoading ? "ProgressRingDots" : "AutoEnhanceOn" }}
                text={isFormattingLoading ? "Formatting" : "Formatter"}
                disabled={isFormattingLoading}
               // onClick={fetchFormattedData}
              />

            </div>
          }  */}

          {showFormatterPopup &&
            <FormatterAgentModal/>
          }

          <div className="refresh-button">
            <PrimaryButton
              iconProps={{
                iconName: "Refresh",
                cursor: "pointer",
              }}
              onClick={() => {
                if (!props.isChild) {
                  refreshReport();
                }
              }}
              style={{ padding: "0px 5px" }}
              text={t("button.refresh")}
            />
            {/* <RefreshIcon />
            <span className="refresh-text">Refresh</span> */}
          </div>
        </div>
      </div>

      )}                
      {isClientReportExist != null &&
        activeTab == 1 &&
        ((!props.isChild && patientReports.length > 0) || props.isChild) && (
          <div
            // className="modal-scroll-annotation"
            // style={{ height: props.isStudyList ? 'unset': height , overflow: "auto" }}
            className={`modal-scroll-annotation ${
              isWordFilePath ? "editor-blurred" : ""
            }`}
           
                  style= {{height: !isMobile ? (enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription ) ?"99%" : "calc(100% - 50px)"): "calc(100vh - 250px)", overflow:"auto" }}
          >
            {!props.isChild ? (
              <FroalaEditor
                tag="textarea"
                config={isMobile && props.readOnly ? emptyConfig: (isWordFilePath ? msWordConfig : config)}
                model={model}
                ref={editorRef}
                onModelChange={(val) => {       
                    handleModelChange(val, false);
                    setDisableCopyButton(!hasText(val));

                }}
                // key={editReport.toString()}
                key={`${editReport.toString()}-${containerHeight}`}
                //style={{marginTop:"20px"}}
              />
            ) : (
              <FroalaEditor
                tag="textarea"
                config={emptyConfig}
                model={childModel}
                ref={editorRef}
                key={"empty"}
                //style={{marginTop:"20px"}}
              />
            )}
          </div>
        )}
      {isClientReportExist != null &&
        activeTab == 1 &&
        patientReports.length == 0 && (
          <div
            className="modal-scroll-annotation"
                        style= {!isMobile ? {height: "calc(100% - 50px)",overflow:"auto"} : {height: "calc(100vh - 250px)", overflow: "auto"}}

          >
            <FroalaEditor
              tag="textarea"
              //config={isWordFilePath ? msWordConfig : emptyConfig}
              config={isMobile && props.readOnly ? emptyConfig: (isWordFilePath ? msWordConfig : emptyConfig)}
              //model={model}
              //onModelChange={handleModelChange}
              key={`${editReport.toString()}-${containerHeight}`}
              //style={{marginTop:"20px"}}
            />
          </div>
        )}
      {isClientReportExist != null && activeTab == 2 && (
        <div
          className="modal-scroll-annotation"
          style={{ height: enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription ) ? "99%" : "calc(100% - 50px)", overflow: "auto" }}
        >
          <FroalaEditor
            tag="textarea"
            //config={isWordFilePath ? msWordConfig : config}
            config={isMobile && props.readOnly ? emptyConfig: (isWordFilePath ? msWordConfig : config)}
            model={addendumModel}
            // key={editReport.toString()}
            key={`${editReport.toString()}-${containerHeight}`}
            ref={editorRef}
            // onModelChange={(val) => {
            //   if (val != addendumModel) {
            //     handleModelChange(val, true);
            //   }
            // }}
            onModelChange={(val) => {
              if (val != addendumModel) {
                handleModelChange(val, true);
                console.log("from last one called ");
                setDisableCopyButton(!hasText(val));
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CustomEditor;

